import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Header.css';

const Header = () => {
  const { tr, lang, toggleLang } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsOpen(o => !o);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { href: '#sobre', label: tr.nav.about },
    { href: '#stack', label: tr.nav.stack },
    { href: '#experiencia', label: tr.nav.experience },
    { href: '#projetos', label: tr.nav.projects },
    { href: '#contato', label: tr.nav.contact },
  ];

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
      <div className="header-logo">
        <a href="#inicio">
          <span className="logo-bracket">{'{ '}</span>JP<span className="logo-bracket">{' }'}</span>
        </a>
      </div>

      <nav className={`header-nav${isOpen ? ' header-nav--open' : ''}`}>
        <ul className="nav-list">
          {navLinks.map(link => (
            <li key={link.href}>
              <a href={link.href} onClick={closeMenu}>{link.label}</a>
            </li>
          ))}
          <li className="nav-cv-mobile">
            <a href="./assets/JOAOCARVALHOP_DESENVOLVEDOR_FULL_STACK.pdf" download onClick={closeMenu}>
              {tr.nav.downloadCV}
            </a>
          </li>
        </ul>
      </nav>

      <div className="header-actions">
        <button className="lang-toggle" onClick={toggleLang} aria-label="Toggle language">
          <span className={lang === 'pt' ? 'lang-active' : ''}>PT</span>
          <span className="lang-sep"> / </span>
          <span className={lang === 'en' ? 'lang-active' : ''}>EN</span>
        </button>
        <a
          className="btn-cv"
          href="./assets/JOAOCARVALHOP_DESENVOLVEDOR_FULL_STACK.pdf"
          download="CV_Joao_Pedro_Carvalho.pdf"
        >
          {tr.nav.downloadCV}
        </a>
      </div>

      <div className="header-mobile-right">
        <button className="lang-toggle" onClick={toggleLang} aria-label="Toggle language">
          <span className={lang === 'pt' ? 'lang-active' : ''}>PT</span>
          <span className="lang-sep">/</span>
          <span className={lang === 'en' ? 'lang-active' : ''}>EN</span>
        </button>
        <button className={`hamburger${isOpen ? ' is-active' : ''}`} onClick={toggleMenu} aria-label="Menu">
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </div>
    </header>
  );
};

export default Header;
